import { render } from "./ConfigurationValue.vue?vue&type=template&id=68f1b31a&scoped=true"
import script from "./ConfigurationValue.vue?vue&type=script&lang=js"
export * from "./ConfigurationValue.vue?vue&type=script&lang=js"

import "./ConfigurationValue.vue?vue&type=style&index=0&id=68f1b31a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f1b31a"]])

export default __exports__